import React from "react";
import { useGetAboutBannerQuery } from "../../../services/AboutAPI";
import Loader from "../fullPageLoader"

function Banner() {
  const { data, error, isLoading } = useGetAboutBannerQuery();

  if (isLoading) return <Loader />;
  if (error) return <p>Failed to load data</p>;

  // Assuming 'data' contains the banners for different pages
  const loginBanner = data?.data?.find(
    (item) => item.page_name === "Login"
  );

  return (
    <div>
      <div
        className="register-banner"
        style={{
          backgroundImage: `url(${loginBanner?.banner_image})`, // Set dynamic background image
          backgroundSize: "cover", // Make sure the background image covers the section
          backgroundPosition: "center", // Center the background image
        }}
      >
        <div className="overlay"></div>
        <div className="banner-content">
          <h1>Reset Password</h1>
        </div>
      </div>
    </div>
  );
}

export default Banner;
